module.exports = __webpack_public_path__ + "img/6-1.5182799f.jpg";